<template>
  <div class="tw:px-4 tw:py-2 tw:flex tw:flex-col tw:bg-white">
    <div class="tw:w-full tw:flex-1">
      <Textarea
        v-model="scriptDetailed.script"
        class="tw:h-[140px] tw:leading-normal tw:text-center"
        :style="{
          fontSize: `${fontSize}px`,
        }"
      />
    </div>
    <div class="tw:mt-3 tw:mb-2 tw:flex tw:gap-2 tw:justify-end">
      <Button
        size="sm"
        variant="secondary"
        @click="cancelEditing"
      >
        Cancel
      </Button>
      <Button
        size="sm"
        variant="primary"
        :disabled="isSaving"
        @click="saveEditing"
      >
        <i
          v-if="isSaving"
          class="tw:i-fas-spinner tw:animate-spin"
        />
        <span>Save</span>
      </Button>
    </div>
  </div>
</template>

<script setup>
import { useVModel } from '@vueuse/core'
import axios from 'axios'
import pick from 'lodash/pick'
import { computed, ref } from 'vue'
import { Button } from '@/shadcn/components/ui/button'
import { Textarea } from '@/shadcn/components/ui/textarea'
import { useTeleprompter } from './use-teleprompter.js'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  fontSize: {
    type: Number,
    default: 16,
  },
})

defineEmits(['update:modelValue'])

const scriptDetailed = useVModel(props)
const { isEditing } = useTeleprompter()
const isSaving = ref(false)

const formData = computed(() => {
  return pick(scriptDetailed.value, [
    'name',
    'owner_id',
    'shared',
    'hash_shared_to_group_ids',
    'script',
  ])
})

function cancelEditing() {
  isEditing.value = false
}

async function saveEditing() {
  try {
    isSaving.value = true

    const res = await axios.put(Spark.router('api.script.update', {
      script: scriptDetailed.value.hash_id,
    }), formData.value)

    scriptDetailed.value = res.data
    isEditing.value = false
  }
  catch (err) {
    await Promise.reject(err)
  }
  finally {
    isSaving.value = false
  }
}
</script>
